import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// /reports is its own page; everything else is the map. Both are lazy so the
// reports page does not load Leaflet and the map bundle, and the map does not
// load the reports. The server already serves index.html for any unknown path.
const Page = window.location.pathname.replace(/\/+$/, '') === '/reports'
  ? lazy(() => import('./Reports'))
  : lazy(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <Page />
    </Suspense>
  </React.StrictMode>
);
